import React, {PureComponent, Component} from 'react';
import Table from '../../../components/table/Table';
import {Col, Button, Card, CardBody,Badge} from 'reactstrap';
import EditProviderForm from './EditProviderForm';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import {
    providers_open_form,
    fetchProvidersDataIfNeeded
} from '../../../redux/actions/ProvidersActions';
import * as TextManager from "../../../modules/languages/TextManager";
import * as environment from '../../../modules/environment';



class ProvidersTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            windowType: 0,
            selectedID: '0',
            saving: false,
            error: false
        };
    }

    editProvider(provider) {
        // this.props.dispatch(fetchProvidersDataIfNeeded(provider));
        this.props.dispatch(providers_open_form(provider));
    }

    addProvider() {
        this.props.dispatch(providers_open_form({
            id: 0,
            name: "",
            deals: [{
                text: "",
                amount: ""
            }],
            image: null
        }));
        this.setState({
            selectedID: 0, windowType: 2, error: false,
        });
    }

    deleteProvider(offer) {

        //abc
        // http.postToServer(
        //     'delete/offer',
        //     {id: offer.id, accountID: offer.accountID},
        //     (response) => {
        //         this.props.dispatch(providers_delete(offer.id));
        //
        //     },
        //     (response) => {
        //         console.log('error delete offer');
        //     }
        // );

    }

    getStatus = (status) => {
        // if (status === 1)
        //     return TextManager.getCurrentTextResource().Utils.active;
        // else
        //     return TextManager.getCurrentTextResource().Utils.inactive;
        return "";
    };

    getStatusColor = (status) => {
        if (status === 1)
            return "success";
        else
            return "danger";
    };

    changeStatus = (index) => {
        // let offer = this.props.data[index];
        // offer.status = offer.status === 1 ? 2 : 1;
        //
        // this.setState({saving: true, error: false});
        //
        // let requestUrl = 'update/offer';
        // http.postToServer(
        //     requestUrl,
        //     offer,
        //     (response) => {
        //
        //         this.setState({saving: false, error: false});
        //         this.props.dispatch(providers_update(response.data));
        //     },
        //     (response) => {
        //         console.warn('error storing', response);
        //         this.setState({saving: false, error: true})
        //
        //     }
        // );
    };

    getRow(provider, index) {

        let logoUrl = environment.getServerBasePath() + '/providers/download?providerID=' + provider.id;
        return (

            <React.Fragment key={provider.id}>

                <tr key={provider.id}>

                    {/*<td>*/}
                    {/*<Badge color={this.getStatusColor(provider.status)} onClick={() => this.changeStatus(index)}*/}
                    {/*style={{cursor: 'pointer'}}>{this.getStatus(provider.status)}</Badge></td>*/}

                    <td>
                        <Button color='primary' size='sm'
                                style={{padding: "0px 15px"}}
                            onClick={() => this.editProvider(provider)}>ערוך</Button>
                    </td>

                    <td>{provider.deals ? provider.deals.map(deal => deal.text).join(", ") : ""}</td>
                    <td>
                        <img src={logoUrl} style={{maxWidth: '200px', objectFit: 'cover' }}/>
                    </td>
                    <td>{provider.name}</td>
                    <td>{provider.id}</td>


                </tr>

                {this.props.provider && provider.id === this.props.provider.id &&
                <tr key={provider.id + 2000}>
                    <td colSpan="7">
                        <EditProviderForm  index={index} onClose={() => this.props.dispatch(providers_open_form(provider))}/>
                    </td>
                </tr>}
            </React.Fragment>
        );
    }

    render() {
        const rows = this.props.data.map((provider, index) =>
            this.getRow(provider, index)
        );

        const isAdding = this.props.provider && this.props.provider.id === 0 && this.state.windowType === 2;

        return (
            <Col md={12} xl={12} lg={12} xs={12}>
                <Card>
                    <CardBody>
                        {isAdding &&
                            <EditProviderForm onClose={() => this.setState({selectedID: 0, windowType: 0})}/>
                        }

                        { !isAdding &&
                        <Table responsive className='table--bordered' dir="rtl">
                            <thead>
                            <tr>
                                <th>
                                    <Button color='primary' size='sm'
                                            style={{padding: "0px 15px", margin: "0px"}}
                                            onClick={() => this.addProvider()}>
                                        <i className="fas fa-plus" > </i>
                                    </Button>
                                </th>
                                <th>{TextManager.getCurrentTextResource().Text.deals}</th>
                                <th>{TextManager.getCurrentTextResource().Providers.image}</th>
                                <th>{TextManager.getCurrentTextResource().Customers.name}</th>
                                <th>{TextManager.getCurrentTextResource().Customers.id}</th>

                            </tr>
                            </thead>
                            <tbody>
                            {rows}
                            </tbody>
                        </Table>
                        }
                    </CardBody>
                </Card>
            </Col>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        status: state.providers.status,
        data: state.providers.data,
        provider: state.providers.provider,
        userData: state.userData
    };
};

export default withRouter(connect(mapStateToProps)(ProvidersTable))